import { useModal } from '@/contexts/modal'
import RefetchIcons from '@/icons/RefetchIcons'
import { CustomerContract } from '@/modules/Contract/types'
import { IPermissionProps } from '@/types/shared'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'vnetwork-ui'

interface IRenewProps extends IPermissionProps {
    contractID?: string
    contract: CustomerContract
}

const Renew: React.FC<IRenewProps> = ({ contractID, contract }) => {
    const { t } = useTranslation()
    const { setModal, open } = useModal()

    // Only show renew button for active contracts
    const canRenew = contract?.contract_status === 'active'

    if (!canRenew) return null

    return (
        <>
            <Button
                size="small"
                variant="contained"
                color="success"
                startIcon={<RefetchIcons />}
                disabled={open}
                onClick={() =>
                    setModal('ContractModals/RenewContractModal/index', {
                        contractID: contractID,
                        contract,
                    })
                }
            >
                {t('renew_contract')}
            </Button>
        </>
    )
}

const RenewComponent = (props: IRenewProps) => {
    return <Renew {...props} />
}

export default RenewComponent
